<template>
    <div id="geolocation">
        <v-alert v-if="wait_validation" class="text-center" color="error" outlined text>
            {{ $t('asset_domicile.refuse_localisation') }}
        </v-alert>

        <v-text-field
            v-if="localisation_domicile"
            v-model="localisation_domicile"
            :label="$t('asset_domicile.address_find')"
            class="rounded-0"
            outlined
            readonly
        />

        <gmap-map ref="map" :center="{ lat: 0, lng: 0 }" class="g-map hidden" />
    </div>
</template>

<script>
export default {
    name: 'geolocation',
    data() {
        return {
            localisation_domicile: null,
            wait_validation: false,
        }
    },
    props: {
        value_type_address: {
            type: Number,
            required: false,
        },
    },
    watch: {
        value_type_address: function (value) {
            if (value === 3) {
                this.getCurrentLocation()
            } else {
                this.localisation_domicile = null
                this.wait_validation = false
            }
        },
    },
    methods: {
        getCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.getDomicileFromGeocode(position.coords.latitude, position.coords.longitude)
                    },
                    () => {
                        this.wait_validation = true
                    },
                )
            } else {
                this.manageError('error', this.$t('asset_domicile.error_browser_localisation'))
            }
        },
        isPlaceValid(place) {
            let count = 0
            place.address_components.forEach((component) => {
                if (
                    component.types.includes('locality') ||
                    component.types.includes('postal_town') || //English case
                    component.types.includes('country') ||
                    component.types.includes('postal_code') ||
                    component.types.includes('plus_code')
                ) {
                    count++
                }
            })
            return count >= 3
        },
        getDomicileFromGeocode(latitude, longitude) {
            let geocoder = new window.google.maps.Geocoder()
            let location = { lat: latitude, lng: longitude }

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === 'OK') {
                    if (results[0] && this.isPlaceValid(results[0])) {
                        this.localisation_domicile = results[0].formatted_address
                        this.$emit('getDomicileFromGeocode', results[0])
                    } else {
                        this.showSnackbar('warning', this.$t('asset_domicile.error_localisation_precision'))
                    }
                } else {
                    this.manageError('error', this.$t('asset_domicile.error_geocode'))
                }
            })
        },
    },
}
</script>

<style scoped></style>
